<template>
    <div class="m-storeUserPermissions">
        <div v-if="!this.isEditable">
            <ui-checkbox-input
                v-for="(permission, idx) in permissionsData"
                :key="idx"
                :label="permission.text"
                :value="isPermissionChecked(permission.value)"
                disabled
                name="m-store-user-permissions"
            />
        </div>
        <div v-else>
            <h2 class="h6 mb-3">{{ title }}</h2>
            <div v-if="subTitle" class="mb-3">
                {{ subTitle }}
            </div>
            <div
                v-for="(permission, idx) in permissionsData"
                :key="idx"
                class="d-flex"
                :class="{
                    'text-primary': isPermissionChecked(permission.value)
                }"
            >
                <a-switch
                    :text="permission.text"
                    :checked="
                        isPermissionChecked(permission.value)
                    "
                    @change="
                        val => onSwitch(val, permission.value)
                    "
                />
                <a-icon
                    v-if="permission.tooltip"
                    class="typo-label icon ml-1"
                    icon="Info"
                    v-tooltip="permission.tooltip"
                    style="width: 18px; height: 18px"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StoreUserPermissions',
    props: {
        permissions: {
            type: Array,
            required: true
        },
        isEditable: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            required: false
        },
        subTitle: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            permissionsData: [
                {
                    value: 'promotions.edit',
                    text: 'Zarządzanie promocjami',
                    tooltip: 'Uprawnienia do aktywacji i przerywania promocji'
                },
                {
                    value: 'promotions.own.edit',
                    text: 'Tworzenie promocji własnych',
                    tooltip: 'Uprawnienia do tworzenia i usuwania promocji własnych'
                },
                {
                    value: 'promotions.code.mapping',
                    text: 'Edycja kodów lokalnych',
                    tooltip: 'Uprawnienia do uzupełniania kodów lokalnych w bazie towarów wagowych'
                },
                {
                    value: 'retr.all',
                    text: 'Dostęp do Rozliczenia retr i Aktualnego retra',
                    tooltip: 'Uprawnienia do podglądu tabeli z rozliczeniem retr, zarządzania reklamacjami oraz przeglądu prognozowanych wartości retrobonusów'
                }
            ]
        }
    },
    methods: {
        onSwitch(val, permission) {
            const permissionTemp = [].concat(this.permissions)
            const addPermission = perm => {
                if (!permissionTemp.includes(perm)) {
                    permissionTemp.push(perm)
                }
            }
            const removePermission = perm => {
                if (permissionTemp.includes(perm)) {
                    permissionTemp.splice(permissionTemp.indexOf(perm), 1)
                }
            }

            switch (permission) {
            case 'promotions.edit':
                if (val) {
                    addPermission('promotions.edit')
                    // remove default promo permission promotions.read
                    removePermission('promotions.read')
                } else {
                    // set default promo permission promotions.read
                    removePermission('promotions.edit')
                    removePermission('promotions.own.edit')
                    addPermission('promotions.read')
                }
                break
            case 'promotions.own.edit':
                if (val) {
                    addPermission('promotions.own.edit')
                    // add 'promotions.edit', remove default promo permission promotions.read
                    addPermission('promotions.edit')
                    removePermission('promotions.read')
                } else {
                    removePermission('promotions.own.edit')
                }
                break
            case 'promotions.code.mapping':
            case 'retr.all':
                if (val) {
                    addPermission(permission)
                } else {
                    removePermission(permission)
                }
                break
            }
            this.$emit('onChange', permissionTemp)
        },
        isPermissionChecked(val) {
            return this.permissions.includes(val)
        }
    }
}
</script>
